<template>
  <div class="tx-dealersearch module-search-results">
    <div class="search-results__results" v-if="!resultsIsEmpty()" :class="{'-gradient': results.length < numberOfTotalItems}">
      <SearchResult
        v-for="(result, index) in results"
        :result="result"
        :key="result.uid"
        :clicked="isClicked(index)"
        @mouseenter="$emit('mouseenterResult', index)"
        @mouseleave="$emit('mouseleaveResult')"/>
    </div>
    <div class="search-results__load-more module-load-more" v-if="!resultsIsEmpty()">
      <div class="load-more__button" v-if="currentPage < numberOfPages">
        <div class="btn -btn-accent" @click="loadMore">
          <span>{{ $t('dealersearch.pagination.button') }}</span>
        </div>
      </div>
      <div class="load-more__progress" v-if="initialized">
        <div class="progress__info">
          <span class="meta" v-html="$t('dealersearch.pagination.info', { current: results.length, total: numberOfTotalItems })"></span>
        </div>
        <div class="pagination__bar">
          <div class="bar__progress" :style="{ width: (results.length / numberOfTotalItems * 100) + '%' }"></div>
        </div>
      </div>
    </div>
    <div class="search-results__error" v-if="loaded && resultsIsEmpty ()">
      <span>{{ $t('dealersearch.filter.error') }}</span>
    </div>
  </div>
</template>

<script>
import SearchResult from '@/components/SearchResult'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SearchResults',
  inject: ['phone'],
  components: {
    SearchResult
  },
  props: {
    clickedPoiIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      results: state => state.dealer.dealers,
      currentPage: state => state.dealer.currentPage,
      itemsPerPage: state => state.dealer.itemsPerPage,
      numberOfPages: state => state.dealer.numberOfPages,
      numberOfTotalItems: state => state.dealer.numberOfTotalDealers,
      loaded: state => state.dealer.loaded
    })
  },
  methods: {
    ...mapActions([
      'loadMore'
    ]),
    resultsIsEmpty () {
      return !(this.results.length > 0)
    },
    isClicked (index) {
      return this.clickedPoiIndex === index
    }
  }
}
</script>
